/* eslint-disable max-len */

import { client } from '../../../../../common-utils/libraries/axios/axios';
import { buildUrl } from '@/common-utils/functions/restUtils';
import simGroupFields from '../../fields/simGroupFields';
import { SIMS_GROUP } from '../apiUrls';


/**
 * @param responseData response.data object
 * @param responseData.activatedSims number
 * @param responseData.consumptionPercentage number
 * @param responseData.monthlyConsumption number
 * @param responseData.organization string
 * @param responseData.simProvider string
 * @param responseData.tariffDataUnit string
 * @param responseData.organizationUuid string
 * @param responseData.tariffData number
 * @param responseData.totalData number
 * @param response
 * @param responseData.items
 * @param responseData.totalResults
 * @returns Mapped data object
 */
function mapResponseData({ items, totalResults }) {
    const data = {};

    const mappedItems = items.map(item => {
        return {
            [simGroupFields.ACTIVATED_SIMS.key]: item[simGroupFields.ACTIVATED_SIMS.key],
            [simGroupFields.CONSUMPTION_PERCENTAGE.key]: item[simGroupFields.CONSUMPTION_PERCENTAGE.key],
            [simGroupFields.DATA_CONSUMPTION.key]: item[simGroupFields.DATA_CONSUMPTION.key],
            [simGroupFields.ORGANIZATION.key]: item[simGroupFields.ORGANIZATION.key],
            [simGroupFields.TARIFF_DATA.key]: item[simGroupFields.TARIFF_DATA.key],
            [simGroupFields.TARIFF_DATA_UNIT.key]: item[simGroupFields.TARIFF_DATA_UNIT.key],
            [simGroupFields.TOTAL_DATA.key]: item[simGroupFields.TOTAL_DATA.key],
            [simGroupFields.PROVIDER.key]: item[simGroupFields.PROVIDER.key],
            [simGroupFields.ORGANIZATION_UUID.key]: item[simGroupFields.ORGANIZATION_UUID.key],
            [simGroupFields.UUID.key]: item[simGroupFields.UUID.key]
        };
    });

    data.items = mappedItems;
    data.totalResults = totalResults;
    return data;
}

const queryGetSimGroups = (query, enabled) => {
    return {
        queryKey: [SIMS_GROUP.COLLECTION.queryKey, query],
        queryFn: async () => {
            const response = await client.get(buildUrl(SIMS_GROUP.COLLECTION.url, query));
            return mapResponseData(response.data);
        },
        enabled: enabled
    };
};


export default queryGetSimGroups;